<mat-card style="width: max-content; max-width: 100%; box-sizing: border-box;">
  <mat-card-header>
    <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
      <div class="left">
        <mat-card-title>
          <div class="header-content">
            <div class="title-section">
              <mat-icon class="header-icon">science</mat-icon>
              <h2>Diagnostic Reports</h2>
            </div>
          </div>
        </mat-card-title>
        <mat-card-subtitle style="margin-top: -12px; margin-bottom: 12px;">
          View and manage patient diagnostic reports and laboratory results.

        </mat-card-subtitle>
      </div>
      <div class="right gap-10 g-just-flex">
        @if(false){
        <div class="action-buttons">
          @if (canAdd$ | async) {
          <button mat-flat-button extended class="secondary-button small-button"
            (click)="router.navigate(['/app/diagnostic-reports/add'])">
            <mat-icon>add</mat-icon>
            Add Report
          </button>
          }
          @if (canExport$ | async) {
          <button mat-flat-button extended (click)="onExportReports()">
            <mat-icon>download</mat-icon>
            Export
          </button>
          }
        </div>}
      </div>
    </div>
  </mat-card-header>

  <!-- <mat-divider></mat-divider> -->

  <mat-card-content>
    <mat-divider></mat-divider>
    <!-- Table Header with Filters -->
    @if (tableHeaderMappedFilterArray && tableHeaderMappedFilterArray.size > 0) {
    <app-table-header [patientsTableFilterArray]="tableHeaderMappedFilterArray!"
      [patientsFiltersFormControlObject]="tableHeaderFiltersFormControlObject">
    </app-table-header>
    }

    <!-- Table -->
    @if (tableDataSource.data.length > 0) {
    <div class="table-container">
      <table mat-table [dataSource]="tableDataSource" class="diagnostic-reports-table">

        <!-- Issued Date Column -->
        <ng-container matColumnDef="issued">
          <th mat-header-cell *matHeaderCellDef>Issued</th>
          <td mat-cell *matCellDef="let row">
            {{ row.issued | date:'short' }}
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-chip" [appChips]="row.status">
              {{ row.status | titlecase }}
            </span>
          </td>
        </ng-container>

        <!-- Category Column -->
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef>Category</th>
          <td mat-cell *matCellDef="let row">
            {{ row.categoryDisplay | na }}
          </td>
        </ng-container>

        <!-- Code Column -->
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef>Test/Report</th>
          <td mat-cell *matCellDef="let row">
            {{ row.code | na }}
          </td>
        </ng-container>

        <!-- Subject Column -->
        <ng-container matColumnDef="subject">
          <th mat-header-cell *matHeaderCellDef>Patient</th>
          <td mat-cell *matCellDef="let row">
            <span [appReferenceDisplay]="row.subject"></span>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row" class="action-column">
            <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="showRow(row)">
                <mat-icon>visibility</mat-icon>
                <span>View Details</span>
              </button>
              @if (row.status === 'final') {
              <button mat-menu-item>
                <mat-icon>edit_note</mat-icon>
                <span>Amend Report</span>
              </button>
              }
              <button mat-menu-item>
                <mat-icon>print</mat-icon>
                <span>Print Report</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="showRow(row)" class="clickable-row">
        </tr>
      </table>
    </div>
    } @else {
    <app-empty-state icon="science" title="No Diagnostic Reports" message="There are no diagnostic reports to display.">
    </app-empty-state>
    }
  </mat-card-content>
</mat-card>